import React, { useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarBlank } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/format";

export function TextField({ label, value, onChange, type = "text", placeholder, required, testId, className }) {
  return (
    <div className={`space-y-1.5 ${className || ""}`}>
      {label && <Label>{label}{required && <span className="text-destructive"> *</span>}</Label>}
      <Input type={type} value={value ?? ""} onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
        placeholder={placeholder} required={required} data-testid={testId} />
    </div>
  );
}

export function AreaField({ label, value, onChange, placeholder, testId, rows = 3 }) {
  return (
    <div className="space-y-1.5">
      {label && <Label>{label}</Label>}
      <Textarea rows={rows} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} />
    </div>
  );
}

export function SelectField({ label, value, onChange, options, placeholder = "Select…", required, testId }) {
  const NONE = "__none__";
  const opts = options.map((o) => {
    const item = typeof o === "string" ? { value: o, label: o } : o;
    return { value: item.value === "" ? NONE : item.value, label: item.label };
  });
  const current = value === "" || value == null ? "" : value;
  return (
    <div className="space-y-1.5">
      {label && <Label>{label}{required && <span className="text-destructive"> *</span>}</Label>}
      <Select value={current} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
        <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>
          {opts.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}

export function DateField({ label, value, onChange, required, testId }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-1.5">
      {label && <Label>{label}{required && <span className="text-destructive"> *</span>}</Label>}
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" className="w-full justify-start font-normal gap-2" data-testid={testId}>
            <CalendarBlank size={16} /> {value ? fmtDate(value) : "Pick a date"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" selected={value ? new Date(value) : undefined}
            onSelect={(d) => { onChange(d ? d.toISOString() : ""); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
    </div>
  );
}
